import type { Locale } from 'antd/es/locale';
import enUS from 'antd/locale/en_US';
import esUS from 'antd/locale/es_US';
import zhCN from 'antd/locale/zh_CN';

import { DEFAULT_LOCALE, type LocaleCode } from '~/i18n';

export const ANTD_LOCALES: Record<LocaleCode, Locale> = {
  'en-US': enUS,
  'es-US': esUS,
  'zh-CN': zhCN,
};

export const getAntdLocale = (locale: LocaleCode = DEFAULT_LOCALE): Locale =>
  ANTD_LOCALES[locale] ?? ANTD_LOCALES[DEFAULT_LOCALE];
